import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AppHeaderComponent } from '../appHeader/appHeader.component';
import { SidebarService } from '@/app/services/shared/sidebar.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    AppHeaderComponent,
    MatExpansionModule,
    MatIconModule,
  ],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent implements OnInit {
  dasboardOpenState = true;
  quickAccessOpenState = false;
  otherProjectsOpenState = false;
  tenderingOpenState = false;
  isOpen = false;

  isHideSidebar = false;
  projectIdNew: any;

  currentTab: string | null = localStorage.getItem('currentTab');
  org_info: any = localStorage.getItem('org_info')
    ? JSON.parse(localStorage.getItem('org_info') as string)
    : null;
  projects: any;
  projectId: any;
  private subscription: Subscription = new Subscription();

  constructor(
    private router: Router,
    private SidebarService: SidebarService,
    private projectsService: ProjectsService,
    private getProjectIdService: GetProjectIdService
  ) {}

  ngOnInit() {
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      this.projectId = id;
    });

    this.SidebarService.sidebarVisibility$.subscribe((isHide) => {
      this.isHideSidebar = isHide;
    });
    this.getAllProjects();
  }
  setIsopen() {
    this.isOpen = !this.isOpen;
  }
  sideBarTabClick(currentTab: string) {
    // console.log('The dashboard have been click');
    localStorage.setItem('currentTab', currentTab);
    this.currentTab = currentTab;
    if (currentTab === 'dashboard') {
      this.router.navigate(['/']);
    } else if (currentTab === 'projects') {
      this.router.navigate(['/projects']);
    }
  }
  navigateToProject() {
    this.router.navigate(['/projects']);
  }
  changeSidebarTab(tab: string) {
    console.log('The tab have been change to ' + tab);
  }
  hideSidebar() {
    console.log('Logic to hidesidebar');
  }

  onTabOpen(id: any) {
    if (id == 1) {
      this.dasboardOpenState = true;
      this.quickAccessOpenState = false;
      this.otherProjectsOpenState = false;
    } else if (id == 2) {
      this.dasboardOpenState = false;
      this.quickAccessOpenState = true;
      this.otherProjectsOpenState = false;
    } else if (id == 3) {
      this.dasboardOpenState = false;
      this.quickAccessOpenState = false;
      this.otherProjectsOpenState = true;
    } else if (id == 4) {
      this.tenderingOpenState = true;
    } else {
      // TODO: redirect to home page
      this.dasboardOpenState = false;
      this.quickAccessOpenState = false;
      this.otherProjectsOpenState = false;
    }
  }

  getAllProjects(): void {
    this.projectsService.getAllProjects().subscribe({
      next: (data) => {
        this.projects = data.data;
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  openProject(project: any) {
    this.projectIdNew = project.id;
    localStorage.setItem('project-name', project.name);
    this.getProjectIdService.setProjectId(project.id);
    this.otherProjectsOpenState = false;
  }

  redirectPage(path: any) {
    this.router.navigate([path]);
  }
}
